"use client";

import React, { forwardRef } from "react";
import * as Primitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Icon } from "../../atoms/Icon/Icon";
import { cn } from "../../lib/cn";

export const Dialog = Primitive.Root;
export const DialogTrigger = Primitive.Trigger;
export const DialogClose = Primitive.Close;

export const DialogOverlay = forwardRef<
  React.ElementRef<typeof Primitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof Primitive.Overlay>
>(({ className = "", ...props }, ref) => (
  <Primitive.Overlay ref={ref} className={cn("fixed inset-0 z-50 bg-neutral-900/50", className)} {...props} />
));
DialogOverlay.displayName = "DialogOverlay";

export const DialogContent = forwardRef<
  React.ElementRef<typeof Primitive.Content>,
  React.ComponentPropsWithoutRef<typeof Primitive.Content>
>(({ className = "", children, ...props }, ref) => (
  <Primitive.Portal>
    <DialogOverlay />
    <Primitive.Content
      ref={ref}
      className={cn(
        "fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2",
        "rounded-lg border border-border bg-surface-raised p-6 shadow-lg focus:outline-none",
        className
      )}
      {...props}
    >
      {children}
      <Primitive.Close
        aria-label="Close"
        className="absolute right-4 top-4 text-text-subtle hover:text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600/40"
      >
        <Icon icon={X} size="sm" />
      </Primitive.Close>
    </Primitive.Content>
  </Primitive.Portal>
));
DialogContent.displayName = "DialogContent";
